import React, { useEffect } from "react";
import { useOutletContext } from "react-router-dom";
import NewProject from "./NewProject";
import NewBudget from "./NewBudget";
import NewProjectStatus from "./NewProjectStatus";
import NewInvoice from "./NewInvoice";
import NewDue from "./NewDues";
import NewManpower from "./NewManpower";
import { useNumber } from "../../../../Context/ProjectIdContext";

function ProjectDashboard() {
    const {number} = useNumber()
  

useEffect(() => {
    if (number) {
      console.log(`number: ${number}`);
       }
  }, [number]);

  return (
    <div className="w-full h-[calc(100vh-145px)] py-2 overflow-y-auto">
      
     
<div className="grid grid-cols-1 lg:grid-cols-6 gap-4">
    <div className="lg:col-span-2 lg:row-span-2"><NewProject projectId={number}/></div>
    <div className="lg:col-span-4 lg:row-span-2 lg:col-start-3"><NewProjectStatus projectId={number}/></div>
    <div className="lg:col-span-3 lg:row-span-2 lg:row-start-3"><NewBudget projectId={number}/></div>
    <div className="lg:col-span-3 lg:row-span-2 lg:col-start-4 lg:row-start-3"><NewInvoice projectId={number}/></div>
    <div className="lg:col-span-4 lg:row-span-2 lg:row-start-5"><NewDue projectId={number}/></div>
    <div className="lg:col-span-2 lg:row-span-2 lg:col-start-5 lg:row-start-5"><NewManpower projectId={number}/></div>
</div>
    
    </div>
  );
}

export default ProjectDashboard;
